import { Injectable } from '@angular/core';
import { loadModules } from 'esri-loader';
import { AppData } from '../providers/app-data';
import { Point } from '../interfaces';

@Injectable()
export class EsriObjectData {

	private appSettings:any;
	public EsriObjects:any;

    constructor(public appData: AppData) {
		this.appSettings = appData.settings;
	}

	async loadEsriObjectsAsync() {
			const options = {
				url: this.appSettings.esriJsApiUrl
			}
			const [Color, Graphic,
				GraphicsLayer, IdentityManager, IdentifyParameters, IdentifyTask,
				FeatureLayer, MapImageLayer, Map, Point, Polyline,
				SimpleRenderer, UniqueValueRenderer,
				Query, LineSymbol, SimpleMarkerSymbol,
				SpatialReference, urlUtils, MapView] = await loadModules([
			'esri/Color', 'esri/Graphic',
					'esri/layers/GraphicsLayer', 'esri/identity/IdentityManager', 'esri/tasks/support/IdentifyParameters', 'esri/tasks/IdentifyTask',
					'esri/layers/FeatureLayer', 'esri/layers/MapImageLayer', 'esri/Map', 'esri/geometry/Point','esri/geometry/Polyline',
					'esri/renderers/SimpleRenderer', 'esri/renderers/UniqueValueRenderer',
					'esri/tasks/support/Query', 'esri/symbols/LineSymbol', 'esri/symbols/SimpleMarkerSymbol',
					'esri/geometry/SpatialReference','esri/core/urlUtils', 'esri/views/MapView'], options);
			this.EsriObjects = {};
			this.EsriObjects.Color = Color;
			this.EsriObjects.Graphic = Graphic;
			this.EsriObjects.GraphicsLayer = GraphicsLayer;
			this.EsriObjects.IdentityManager = IdentityManager;
			this.EsriObjects.IdentifyParameters = IdentifyParameters;
			this.EsriObjects.IdentifyTask = IdentifyTask;
			this.EsriObjects.FeatureLayer = FeatureLayer;
			this.EsriObjects.MapImageLayer = MapImageLayer;
			this.EsriObjects.Map = Map;
			this.EsriObjects.Point = Point;
			this.EsriObjects.Polyline = Polyline;
			this.EsriObjects.SimpleRenderer = SimpleRenderer;
			this.EsriObjects.UniqueValueRenderer = UniqueValueRenderer;
			this.EsriObjects.Query = Query;
			this.EsriObjects.SimpleLineSymbol = LineSymbol;
			this.EsriObjects.SimpleMarkerSymbol = SimpleMarkerSymbol;
			this.EsriObjects.SpatialReference = SpatialReference;
			this.EsriObjects.urlUtils = urlUtils;
			this.EsriObjects.MapView = MapView;
			return this.EsriObjects;
			
	}

	getGeographicPoint(x: number, y: number): Point {
		return this.getPoint(x, y, 4326);
	}

	getMercatorPoint(x: number, y: number): Point {
		return this.getPoint(x, y, 102100);
	}

	getPoint(x: number, y: number, wkid: number): Point {
		return this.EsriObjects.Point({"x": x, "y": y, "spatialReference": new this.EsriObjects.SpatialReference({ 'wkid': wkid })});
	}

	getPolyline(paths:Array<any>, wkid: number): Point {
		return this.EsriObjects.Polyline({"paths": paths, "spatialReference": new this.EsriObjects.SpatialReference({ 'wkid': wkid })});
	}

	getGeometry(geometryObject: any) {
		if (geometryObject.geometryType){
			let geometryType:string = geometryObject.geometryType.toLowerCase();
			if (geometryType.indexOf("point") >=0) {
				return this.getPoint(geometryObject.x, geometryObject.y, geometryObject.spatialReference.wkid);
			} else if (geometryType.indexOf("polyline") >=0) {
				return this.getPolyline(geometryObject.paths, geometryObject.spatialReference.wkid);
			}
		}
		return null;
	}

	getEsriGeometryString(geometryType: string) {
		geometryType = geometryType.toLowerCase();
		if (geometryType === "point") {
			return "EsriGeometryPoint";
		} else if (geometryType === "polyline") {
			return "EsriGeometryPolyline";
		} else if (geometryType === "polygon") {
			return "EsriGeometryPolygon";
		}
	}

}


// WEBPACK FOOTER //
// ./src/providers/esri-object-data.ts